import { useEffect, useState } from "react";

/**
 * Trailing-edge debounce for values that drive a request — a search box, a
 * filter — so typing doesn't fire one call per keystroke.
 */
export function useDebounce(value, delay = 400) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}

export default useDebounce;
